import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import KlausA1 from '../views/KlausA1.vue'
import KlausA3 from '../views/KlausA3.vue'
import RoboKlaus from '../views/RoboKlaus.vue'
import CentralKlaus from '../views/CentralKlaus.vue'
import KPDF from "../views/KPDF.vue"
import ComponenteNFSe from "../views/ComponenteNFSe.vue"
import RoboKlausLite from '../views/RoboKlausLite.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/klaus-a1',
    name: 'KlausA1',
    component: KlausA1
  },
  {
    path: '/klaus-a3',
    name: 'KlausA3',
    component: KlausA3
  },
  {
    path: '/robo-klaus',
    name: 'RoboKlaus',
    component: RoboKlaus
  },
  {
    path: '/central-klaus',
    name: 'CentralKlaus',
    component: CentralKlaus
  },
  {
    path: '/kpdf',
    name: 'KPDF',
    component: KPDF
  },
  {
    path: '/componente-nfse',
    name: 'ComponenteNFSe',
    component: ComponenteNFSe
  },
  {
    path: '/robo-klaus-lite',
    name: 'RoboKlausLite',
    component: RoboKlausLite
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
